<template>
  <div>
    <authentication-forms-container :image="image">
      <h1 class="text-primary text-center">تایید ایمیل</h1>
      <b-form>
        <router-link :to="{ name: 'Profile' }">
          <b-button block pill type="submit" class="my-5 w-100" variant="primary"
          >بازگشت به پروفایل
          </b-button>
        </router-link>
      </b-form>
    </authentication-forms-container>
  </div>
</template>
<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import AuthenticationFormsContainer from "../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";
import router from "@/router";


export default {
  name: "verifiedEmail1",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  props: {
    image: {
      type: String,
      default: require('../../assets/login.png')
    }
  },
  mounted() {
    const id = router.currentRoute.params.id;
    const hash = router.currentRoute.params.hash;
    const expires = router.currentRoute.query.expires;
    const signature = router.currentRoute.query.signature;
    const form = {
      id: id,
      hash: hash,
      expires: expires,
      signature: signature,
    };

    this.$store.dispatch("Authentication/verifyEmail", form);
  },
};
</script>
<style scoped></style>